module.exports = __webpack_public_path__ + "static/media/heart-icon.f634a4e7.svg";